import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Modal, Button } from "components/common"
import { useDispatch, useSelector } from "react-redux"
import { createTemplatePolicy, updateTemplatePolicy } from "redux/templatePoliciesSlice"
import { FaFolder } from "react-icons/fa"

import { INPUT_CLS as INPUT_CLASSES } from 'helpers/formStyles';
const TemplatePolicyFolderForm = ({ show, onHide, onSuccess, parentId, asset, mode }) => {
  const [folderName, setFolderName] = useState("")
  const [validated, setValidated] = useState(false)
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.template_policies)

  useEffect(() => {
    if (mode === "rename" && asset) {
      setFolderName(asset.name || "")
    } else {
      setFolderName("")
    }
  }, [mode, asset])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!folderName.trim()) {
      setValidated(true)
      return
    }

    try {
      if (mode === "create") {
        await dispatch(createTemplatePolicy({
          name: folderName,
          parent_id: parentId || null
        })).unwrap()
      } else {
        await dispatch(updateTemplatePolicy({
          assetId: asset.id,
          data: { name: folderName }
        })).unwrap()
      }

      onSuccess()
      setFolderName("")
      setValidated(false)
    } catch (error) {
      // Error is handled by Redux slice
    }
  }

  const handleClose = () => {
    setFolderName("")
    setValidated(false)
    onHide()
  }

  const isFolder = !asset || asset.asset_type === "folder"
  const itemType = isFolder ? "Folder" : "File"

  return (
    <Modal
      show={show}
      onHide={handleClose}
      title={(
        <>
          <FaFolder className="tw-mr-2 tw-text-yellow-500" />
          {mode === "create" ? "Create New Folder" : `Rename ${itemType}`}
        </>
      )}
      footer={(
        <>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading} form="template-policy-folder-form">
            {loading ? "Saving..." : mode === "create" ? "Create" : "Save"}
          </Button>
        </>
      )}
    >
      <form id="template-policy-folder-form" noValidate onSubmit={handleSubmit}>
        <label htmlFor="folderName" className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1">
          {itemType} Name
        </label>
        <input
          id="folderName"
          type="text"
          placeholder={`Enter ${itemType.toLowerCase()} name`}
          className={INPUT_CLASSES}
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
          required
          autoFocus
        />
        {validated && !folderName.trim() && (
          <span className="tw-text-red-600 tw-text-xs tw-mt-1 tw-block">
            Please enter a {itemType.toLowerCase()} name.
          </span>
        )}
      </form>
    </Modal>
  )
}

TemplatePolicyFolderForm.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  parentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  asset: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    asset_type: PropTypes.string
  }),
  mode: PropTypes.oneOf(["create", "rename"]).isRequired
}

export default TemplatePolicyFolderForm
